import React, { useState, useEffect } from 'react';
import { useUser } from '../contexts/UserContext';
import Swal from 'sweetalert2';
import { useAccesos } from '../contexts/AccesosContext';
function AddRaza({ handleNewRaza, editRaza }) {
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [descripcion, setDescripcion] = useState('');
    const [modificacion, setModificacion] = useState('');
    const [IngresadoPor, setIngresadoPor] = useState('');

    const { user } = useUser();
    const { tienePermiso } = useAccesos();
    // Obtener la fecha y hora actual
    function obtenerFechaISOsinZ() {
        const fecha = new Date();
        let fechaISO = fecha.toISOString(); // "2024-07-30T22:14:46.271Z"
        fechaISO = fechaISO.slice(0, -1); // Elimina la última posición, que es la 'Z'
        return fechaISO;
    }

    // Convertir a una cadena en formato ISO 8601
    const fechaFormateada = obtenerFechaISOsinZ();
    // Carga inicial de datos si estamos en modo edición
    useEffect(() => {
        if (editRaza) {
            setDescripcion(editRaza.descripcion); // Cargar la descripción de la raza para editar
            setModificacion(2);
            setIngresadoPor(editRaza.ingresadoPor);

        } else {
            setDescripcion(''); // Resetear la descripción si no estamos editando
            setModificacion(1);
            setIngresadoPor('');

        }
    }, [editRaza]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const method = editRaza ? 'PUT' : 'POST'; // Usar PUT para actualizar y POST para crear
        const endpoint = editRaza ? `${server}/MgRazas/${editRaza.id}` : `${server}/MgRazas`;

        const raza = { 
            id:editRaza ? editRaza.id:0,
            descripcion,
            IngresadoPor: !editRaza ? (user ? user.codigoUsuario : 'ADMIN               ') : IngresadoPor,
            ModificadoPor: editRaza ? (user ? user.codigoUsuario : 'ADMIN               ') : undefined,
         
        };
        Object.keys(raza).forEach(key => raza[key] === undefined && delete raza[key]);

        try {
            const response = await fetch(endpoint, {
                method: method,
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(raza),
            });

            if (response.ok) {
                // Limpiar el formulario y manejar la respuesta si es necesario
                setDescripcion('');
                Swal.fire({
                    icon: 'success',
                    title: 'Operación exitosa',
                    showConfirmButton: false,
                    timer: 1500
                });         
                       handleNewRaza();
            } else {
                const errorData = await response.json();
                const errorMessage = errorData.message || (errorData.errors ? Object.values(errorData.errors).flat().join(', ') : 'Ocurrió un error inesperado');
                Swal.fire({
                    icon: 'error',
                    title: `Error ${response.status}`,
                    text: errorMessage,
                });            }
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error al guardar la raza',
                text: error || 'Ocurrió un error inesperado',
            });        }
    };

    return (
        <>
            <h2>{editRaza ? 'Editar Raza' : 'Agregar Nueva Raza'}</h2>
            <br />
            <form id="formRaza" className="form-horizontal form-label-left" onSubmit={handleSubmit}>
                <div className="item form-group">
                    <label className="col-form-label col-md-3 col-sm-3 label-align" htmlFor="descripcionRaza">
                        Descripción: <span className="required">*</span>
                    </label>
                    <div className="col-md-2 col-sm-3">
                        <input
                            type="text"
                            id="descripcionRaza"
                            required="required"
                            className="form-control"
                            value={descripcion}
                            onChange={(e) => setDescripcion(e.target.value)}
                        />
                    </div>
                </div>

                <div className="ln_solid" />
                <div className="item form-group">
                    <div className="col-md-6 col-sm-6 offset-md-3">
                        <button type="submit" className="btn btn-success" disabled={!tienePermiso('Crear Raza')}>
                            {editRaza ? 'Actualizar' : 'Guardar'}
                        </button>
                    </div>
                </div>
            </form>
        </>
    );
}

export default AddRaza;
